// src/components/Resume/ResumeData.js
import CSNA from "../../Assets/Resume/CSNA.pdf";
import CSNE from "../../Assets/Resume/CSNE.pdf";

export const educationData = [
  {
    year: "2024",
    title: "Certified Stormshield Network Expert",
    institution: "Stormshield",
    location: "Distanciel",
    description: "",
    link: CSNE,
  },
  {
    year: "2021",
    title: "Certified Stormshield Network Administrator",
    institution: "Stormshield",
    location: "Lyon",
    description: "",
    link: CSNA,
  },
  {
    year: "2021",
    title: "Licence Professionnelle Métiers des Réseaux Informatiques et des Télécommunications – spécialité Administration et Sécurité des Réseaux",
    institution: "IUT des Pays de l'Adour",
    location: "Mont De Marsan",
    description: "",
  },
  {
    year: "2020",
    title:
      "Brevet de Technicien Supérieur SIO – Option Solutions d'Infrastructure, Systèmes et Réseaux",
    institution: "Lycée Saint John Perse",
    location: "Pau",
    description: "",
  },
  {
    year: "2018",
    title:
      "Bac Professionnel Systèmes Eléctroniques Numériques Champ Télécommunications et Réseaux",
    institution: "Lycée Professionnel Ramiro Arrué",
    location: "Saint-Jean-de-Luz",
    description: "",
  },
  {
    year: "2017",
    title:
      "Brevet d'Études Professionnelles Systèmes Electroniques Numérique",
    institution: "Lycée Professionnel Ramiro Arrué",
    location: "Saint-Jean-de-Luz",
    description: "",
  },
];

export const experienceData = [
  {
    period: "Mars 2026 – Aujourd’hui",
    title: "Bénévole – Expert National",
    company: "WorldSkills France",
    location: "France",
    description: [
      "Gestion de l’équipe métier",
      "Gestion de projet et du budget",
      "Communication avec les jurés regionaux",
      "Rédaction des sujets de compétitions",
    ],
  },
  {
    period: "Septembre 2021 – Aujourd’hui",
    title: "Administrateur Systèmes et Réseaux",
    company: "ADITU",
    location: "Bidart",
    description: [
      "Exploitation de deux datacenters (ISO 27001, HDS)",
      "Administration des infrastructures clients et datacenters",
      "Astreintes plateforme et clients 24/7",
      "Supervision des infrastructures (datacenters et clients)",
      "Administration des tenants Microsoft 365",
    ],
  },
  {
    period: "Octobre 2025 – Aujourd’hui",
    title: "Bénévole – Ambassadeur",
    company: "WorldSkills France",
    location: "France",
    description: [
      "Visite et présentation de la compétition auprès des partenaires",
    ],
  },
  {
    period: "Juillet 2024 – Aujourd’hui",
    title: "Bénévole – Expert Europe",
    company: "WorldSkills France",
    location: "France",
    description: [
      "Gestion de l’équipe métier",
      "Gestion de projet et du budget",
      "Communication avec les autres experts",
      "Formation et accompagnement des compétiteurs (Herning 2025 : 8ᵉ)",
    ],
  },
  {
    period: "Octobre 2022 – Aujourd’hui",
    title: "Bénévole – Juré, Chef d'atelier et Coach",
    company: "Nouvelle-Aquitaine",
    location: "Bordeaux",
    description: [
      "Noter la prestation des compétiteurs",
      "Rédiger les sujets de compétition",
      "Préparation de la compétition",
      "Installation du matériel sur le site de compétition",
      "Maintien du matériel en condition opérationnelle",
      "Maintien de l’ordre et de la propreté dans les ateliers",
      "Formation et accompagnement du compétiteur régional (Lyon 2023 : 2ᵉ)",
    ],
  },
  {
    period: "Février 2023 – Mai 2023",
    title: "Bénévole – Juré France & Workshop Manager (Metz2023)",
    company: "Abilympics France",
    location: "France",
    description: [
      "Notation de la prestation des compétiteurs",
      "Préparation de la compétition",
      "Installation du matériel sur le site de compétition",
      "Maintien du matériel en condition opérationnelle",
      "Maintien de l’ordre et de la propreté dans les ateliers",
      "Formation et accompagnement des compétiteurs (Metz 2023 : 3ᵉ et 4ᵉ)",
    ],
  },
  {
    period: "Juin 2020 – Juillet 2022",
    title: "Apprenti Administrateur Systèmes et Réseaux",
    company: "ADITU",
    location: "Bidart",
    description: [
      "Exploitation de deux datacenters, dont un agréé Hébergeur de Données de Santé à caractère personnel (HDS)",
      "Administration des infrastructures clients",
      "Administration des infrastructures des datacenters",
      "Supervision des environnements systèmes et réseaux (datacenters et clients)",
      "Migration de la solution antispam MailCleaner vers Mailinblack",
    ],
  },
  {
    period: "Juin 2018 – Janvier 2022",
    title: "Compétiteur régional — Administration des systèmes et réseaux informatiques",
    company: "Nouvelle-Aquitaine",
    location: "France",
    description: [
      "Mise en situation technique (infrastructures Microsoft, infrastructures Linux, réseau Cisco, troubleshooting) sans Internet",
      "Résultat Bordeaux 2018: 2ᵉ",
      "Résultat Bordeaux 2020: 1ᵉʳ",
      "Résultat Lyon 2022: 5ᵉ",
    ],
  },
  {
    period: "Janvier 2020 – Février 2020",
    title: "Stagiaire assistant informatique",
    company: "GIE-TALDEA",
    location: "Saint-Martin-de-Seignanx",
    description: [
      "Mise en place d’une campagne de phishing pédagogique (Gophish) pour sensibiliser les salariés aux risques liés à la sécurité informatique",
      "Déploiement d’une solution de supervision des équipements systèmes et réseaux (EyesOfNetwork)",
      "Installation et configuration d’un serveur Nextcloud (stockage et partage de fichiers)",
      "Mise en place de partages DFS sous Windows Server 2012 R2",
    ],
  },
  {
    period: "Juillet 2019 – Août 2019",
    title: "Assistant informatique",
    company: "SOCOMIX - Hôtel du Palais",
    location: "Biarritz",
    description: [
      "Réouverture de l’hôtel : mise en place du matériel, déploiement de logiciels, formation du personnel et assistance auprès des clients et des salariés",
      "Sommet du G7 : assistance auprès des salariés et des délégations",
    ],
  },
  {
    period: "Mai 2019 – Juin 2019",
    title: "Stagiaire Assistant informatique",
    company: "SOCOMIX - Hôtel du Palais",
    location: "Biarritz",
    description: [
      "Formation et accompagnement du personnel",
      "Assistance technique auprès des salariés",
      "Mise en place et configuration du nouveau parc informatique suite au rachat de l’hôtel par Hyatt",
    ],
  },
  {
    period: "Juillet 2018 – Août 2018",
    title: "Assistant informatique",
    company: "SOCOMIX - Hôtel du Palais",
    location: "Biarritz",
    description: [
      "Mise en place d’une solution d’ITSM (gestion des services informatiques – GLPI)",
      "Formation et accompagnement du personnel",
      "Assistance auprès des clients et des salariés",
    ],
  },
  {
    period: "Février 2018 – Février 2018",
    title: "Stagiaire Assistant informatique",
    company: "SOCOMIX - Hôtel du Palais",
    location: "Biarritz",
    description: [
      "Mise en place du nouveau parc informatique",
      "Maintenance du parc informatique",
    ],
  },
  {
    period: "Novembre 2017 – Novembre 2017",
    title: "Stagiaire Assistant informatique",
    company: "TALIS-BS",
    location: "Bayonne",
    description: [
      "Mise en place d'une solution de supervision (Observium)",
      "Maintenance du parc informatique",
    ],
  },
  {
    period: "Juillet 2017 – Août 2017",
    title: "Assistant informatique",
    company: "SOCOMIX - Hôtel du Palais",
    location: "Biarritz",
    description: [
      "Formation du personnel",
      "Assistance technique (clients et salariés)",
      "Maintenance de bases de données",
    ],
  },
  {
    period: "Juillet 2017 – Août 2017",
    title: "Stagiaire Assistant informatique",
    company: "SOCOMIX - Hôtel du Palais",
    location: "Biarritz",
    description: [
      "Formation du personnel",
      "Assistance technique (clients et salariés)",
    ],
  },
  {
    period: "Juillet 2017 – Août 2017",
    title: "Stagiaire",
    company: "SUDE TELECOM - CAUM",
    location: "Mouguerre",
    description: [
      "Installation de liens ADSL et fibre optique",
      "Intervention sur dérangement",
    ],
  },
  {
    period: "Mai 2016 – Mai 2016",
    title: "Stagiaire",
    company: "HTP MULTIMEDIA",
    location: "Biarritz",
    description: [
      "Conseil informatique",
      "Maintenance des ordinateurs",
    ],
  },
  {
    period: "Janvier 2016 – Janvier 2016",
    title: "Stagiaire",
    company: "COBASUR",
    location: "Saint Jean de Luz",
    description: [
      "Installation d’alarmes intrusion et de vidéosurveillance",
      "Maintenance d’alarmes intrusion",
    ],
  },
];
